import {
  getGuest,
  guestUpdateEvent,
  initiateGuestSession,
  updateGuest
} from 'lib/auth/guestSystem';
import { useSyncExternalStore } from 'react';
import type { GuestIdentityService } from './GuestIdentityService';

/** The guest lives where the v4 pages keep it (`lib/auth/guestSystem`), so both pages share one. */
export function createGuestIdentityService(config: {
  isSignedIn: () => boolean;
}): GuestIdentityService {
  // storage can be blocked (a private window, site data off) or hold another shape: no guest then
  const storedGuest = () => {
    try {
      return localStorage.getItem('Stitch.Guest') === null
        ? undefined
        : getGuest();
    } catch {
      return undefined;
    }
  };

  return {
    useVisitor: access => {
      useSyncExternalStore(
        guestUpdateEvent.addListener,
        () => guestUpdateEvent.counter
      );
      return access === 'member' && config.isSignedIn()
        ? { type: 'member' }
        : {
            type: 'guest',
            id: storedGuest()?.id ?? null,
            name: storedGuest()?.full_name || null
          };
    },
    getGuestId: () => storedGuest()?.id ?? null,
    ensureVoter: access => {
      if (access === 'member' && config.isSignedIn()) return { type: 'member' };
      const guest = initiateGuestSession();
      return { type: 'guest', id: guest.id, name: guest.full_name || null };
    },
    setGuestName: name =>
      updateGuest({ ...initiateGuestSession(), full_name: name })
  };
}
